export class SaveCreatedProjectId {
    public static readonly type = "[Projects] Save created project id";

    constructor(public payload: string) {}
}
